import { call, put } from 'redux-saga/effects';
import { FRONT_URL } from '../../../configs';
import { authorizedLoginFailed, authorizedLogoutSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import processError from '../../../utils/processError';

export default function* authorizedLogout(action) {
  try {
    if (window.updateTimers && window.updateTimers.length) {
      for (let i = 0, len = window.updateTimers.length; i < len; i++) {
        clearTimeout(window.updateTimers[i]);
      }
    }
    const logout = yield window.keycloak.logout({ redirectUri: FRONT_URL });
    yield put(authorizedLogoutSuccessful());
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield put(authorizedLoginFailed());
    yield processError(e);
  }
}
